var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    { staticClass: "is-size-7" },
    [
      _c("span", { staticClass: "has-text-grey-light" }, [
        _vm._v("Don't have a Mobile Number?")
      ]),
      _vm._v(" "),
      _c(
        "BaseCollapsible",
        {
          scopedSlots: _vm._u([
            {
              key: "collapsibleTrigger",
              fn: function(ref) {
                var toggleCollapsible = ref.toggleCollapsible
                return [
                  _c(
                    "a",
                    {
                      staticClass: "tp-link",
                      attrs: {
                        tabindex: "0",
                        "aria-label":
                          "If you don't have a mobile number click here."
                      },
                      on: {
                        click: toggleCollapsible,
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return toggleCollapsible($event)
                        }
                      }
                    },
                    [_vm._v("Click Here")]
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("template", { slot: "collapsibleContent" }, [
            _c("div", [
              _c("p", { attrs: { tabindex: "0" } }, [
                _vm._v(
                  "\n          Our online ordering system requires the use of a mobile number so we can send you a secure login PIN, like your bank. When you log in to your account, you can see your order progress tracker in real time. If you do not have a mobile phone or would prefer not to use your mobile phone for mobile ordering, please call this store at:\n          "
                ),
                _c(
                  "a",
                  {
                    staticClass: "tp-link",
                    attrs: { href: "tel:" + _vm.location.contactPhone }
                  },
                  [_vm._v(_vm._s(_vm.formatPhone(_vm.location.contactPhone)))]
                ),
                _vm._v(".\n        ")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("p", { attrs: { tabindex: "0" } }, [
                _vm._v(
                  "You will still earn the same points if you order online, call the store or visit us.\n          "
                ),
                _c("br"),
                _vm._v(
                  "We're happy to serve and reward you on every channel!\n        "
                )
              ])
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ab99dec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab99dec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/PhonelessUserCollapsible.vue
// module id = null
// module chunks = 